module.exports = __webpack_public_path__ + "img/ROSTOV.2a645b07.png";